function generateImageUrls(prefix: string, count: number): string[] {
  const urls = [];
  for (let i = 1; i <= count; i++) {
    urls.push(`assets/img/rooms/${prefix}_${i}.jpg`);
  }
  return urls;
}
export const environment = {
  production: true,
  url: '',
  api_url: 'https://kombornia-booking.virtualreception.pl/api/',
  hotel_name: 'Hotel Kombornia',
  privacy_policy: '',
  hotel_rules: 'https://virtualreception.pl/docs/kombornia',
  hotel_url: 'https://kombornia.pl',
  html_title: "Hotel Kombornia",
  instagram_url: '',
  facebook_url: '',
  linkedin_url: '',
  asorts: true,
  isBreakfastRequired: false,
  isBreakfastDefaultSelected: false,
  breakfastCheckbox: false,
  localizationSelect: true,
  parkingOptionActive: false,
  rabatInput: true,
  isApart: false,
  minimalStayDays: 1,
  // opcjonalne funkcje do włączenia parametrem
  voucherOptionActive: false,
  offersOptionActive: false,
  breakfastOptionActive: true,
  localChargeOptionActive: false,
  // 
  localCharge: false,
  paymentImagePath: 'assets/img/background.jpg',
  isLanguageChange: false,
  gtm: false,
  gtmtag: '',
  hiddenIcons: false,
  favicon_url: '',
  layoutSettings: {
    footer: {
      addressLine1: 'Hotel | Restauracja | SPA Kombornia',
      addressLine2: 'ul. Dworska 52, 38-420 Korczyna k/Krosna',
    },
  },
  messageForNoRooms: 'Brak pokoi w wybranym terminie',
  roomTypeToImagesMap: {
    "Stanowisko Standard": generateImageUrls('kamper', 7),
    "Stanowisko XL": generateImageUrls('kamper', 7),
    "Stanowisko Ekonomiczne": generateImageUrls('kamper', 7),
    "Gościnny": generateImageUrls('goscinny', 5),
  },
  cookiesOptionActive: true,
  offersSettings: {},
  roomDetails: false,
  rooms: [{}],
  redirectToOtherHotel: {
    on: false,
    text: ""
  },
  forceBreakfast: false,
  defaultLanguage: 'pl',
};
